<template>
    <div class="catalog-wrapper">
        <div
            :class="isShowCata ? 'show-cata-ani' : 'hide-cata-ani'" 
            class="bk-catalog pb-show-display" 
            :data-pblog="pblogData"
        >
            <div class="title">
                <div class="catalog-icon" @click="hide"></div>
                <div class="label">目录</div>
            </div>
            <div
                class="catalog-content"
                @scroll="scrollHandle"
                @touchend="touchend"
            >
                <div
                    v-for="(item,index) of titleList"
                    v-show="!!item || index !== 1"
                    :key="index"
                    :class="{'current': currentIndex === index}"
                    class="catalog-item"
                    @click.stop="changeCatalog(index)"
                >
                    <i>{{ index | titleIndex }} </i>{{ item }}
                </div>
            </div>
        </div>
        <div
            :class="isShowCata ? 'hide-mini-ani' : 'show-mini-ani'"
            class="catalog-mini"
            @click="show"
        >
            <div class="catalog-big-icon"></div>
            <div class="label">目录</div>
        </div>
        <div
            :class="isShowContentAll ? 'show-fold-ani' : 'hide-fold-ani'"
            class="fold-mini"
            @click="foldContent"
        >
            <div class="fold-icon"></div>
            <div class="label">收起</div>
        </div>
    </div>
</template>

<script>
    import { on } from '@/utils/dom';
    import { throttle } from 'throttle-debounce';
    let self = null;
    export default {
        filters: {
            titleIndex(index) {
                if (!self) {
                    if (index === 0) {
                        return '';
                    } else {
                        return index > 9 ? `${index}.` : `0${index}.`;
                    }
                }
                if (index === 0) {
                    return '';
                } else if (self.titleList.length > 1 && !!self.titleList[1]) {
                    return index > 9 ? `${index}.` : `0${index}.`;
                } else if (self.titleList.length > 1 && !self.titleList[1]) {
                    return index > 10 ? `${index - 1}.` : `0${index -1}.`;
                } else {
                    return index > 9 ? `${index}.` : `0${index}.`;
                }
            }
        },
        props: {
            titleList: {
                type: Array,
                default: () => ([])
            },
            isShowCata: {
                type: Boolean,
                default: false
            },
            isShowCataClock: {
                type: Boolean,
                default: false
            },
            currentIndex: {
                type: Number,
                default: 0
            },
            // 是否百科内容全部展开
            isShowContentAll: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                pblogData: {}
            }
        },
        watch: {
            isShowCataClock() {
                // 设置带3秒倒计时的展开目录
                this.$emit('showCatalog');
                this.$emit('shieldScrollEvent', true);
                if (this.showClockTimer) {
                    clearTimeout(this.showClockTimer);
                    this.showClockTimer = false;
                }
                this.showClockTimer = setTimeout(() => {
                    clearTimeout(this.showClockTimer);
                    this.showClockTimer = false;
                    this.$emit('hideCatalog');
                    this.$emit('shieldScrollEvent', false);
                }, 3000);
            },
            isShowCata(val) {
                if (!val) {
                    if (this.showClockTimer) {
                        clearTimeout(this.showClockTimer);
                    }
                    this.$emit('shieldScrollEvent', false);
                }
            },
            '$root.bkAnchor': function(val) {
                val = this.titleList[1] ? val : val + 1;
                this.changeCatalog(val);
            }
        },
        created() {
            self = this;
        },
        mounted() {
            let dom = document.getElementById('catalog-content');
            on(dom, 'scroll', throttle(200, this.scrollHandle));
            on(dom, 'touchend', throttle(200, this.touchend));
            this.pblogData = JSON.stringify({
                value: 'catalog',
                ext: {
                    id: '',
                    ext: Object.assign({}, this.$root.extData),
                    pos: ''
                }
            })
            
        },
        methods: {
            changeCatalog(index) {
                this.$emit('changeBlock', index);
            },
            hide() {
                this.$emit('hideCatalog');
            },
            show() {
                this.$emit('showCatalog');
                if (this.showClockTimer) {
                    clearTimeout(this.showClockTimer);
                    this.showClockTimer = false;
                }
                this.showClockTimer = setTimeout(() => {
                    clearTimeout(this.showClockTimer);
                    this.showClockTimer = false;
                    this.hide();
                }, 3000);
            },
            foldContent() {
                this.$emit('foldBaiKe', 'float');
            },
            scrollHandle() {
                this.isScrolling = true;
            },
            touchend() {
                if (this.isScrolling) {
                    let content = {
                        value: 'slide',
                        ext: {
                            id: '',
                            ext: Object.assign({moduleName: '目录'}, this.$root.extData),
                            pos: ''
                        }
                    }
                    this.$logger.click(content);
                    this.isScrolling = false;
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .bk-catalog {
        position: fixed;
        max-height: px2rem(1207);
        width: px2rem(480);
        bottom: px2rem(493);
        right: px2rem(-480);
        background-color: #FFFFFF;
        border-bottom: 1px solid transparent;
        border-radius: px2rem(27) 0 0 px2rem(27);
        overflow: hidden;
        box-shadow: 0 0 30px 0 rgba(0,0,0,0.16);
        z-index: 9999;
        &.hide-cata-ani {
            transform: translateX(px2rem(480));
            transition: transform .24s ease 0s;
        }
        &.show-cata-ani {
            transform: translateX(px2rem(-480));
            transition: transform .3s ease .24s;
        }
        .title {
            position: relative;
            height: px2rem(138);
            display: flex;
            align-items: center;
            padding: 0 px2rem(54);
            border-bottom: px2rem(1) solid #E0E0E0;
            .catalog-icon {
                width: px2rem(48);
                height: px2rem(38);
                background: url('~public/assets/imgs/ic_catalog_little.png') no-repeat;
                background-size: cover;
                margin-right: px2rem(27);
            }
            .label {
                font-size: px2rem(48);
                color: #3388FF;
                font-weight: 500;
            }
        }
        .catalog-content {
            display: flex;
            flex-direction: column;
            font-size: px2rem(48);
            color: #858585;
            max-height: px2rem(1008);
            width: px2rem(480);
            overflow-y: scroll;
            overflow-x: hidden;
            padding: px2rem(30) 0;
            border-bottom: 1px solid transparent;
            .catalog-item {
                height: px2rem(168);
                flex: 0 0 px2rem(168);
                padding: 0 px2rem(54);
                line-height: px2rem(168);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &.current {
                    color: #1F1F1F;
                }
            }
        }
    }
    .catalog-mini {
        position: fixed;
        bottom: px2rem(565);
        right: px2rem(-184);
        width: px2rem(184);
        height: px2rem(184);
        background-color: #FFFFFF;
        box-shadow: 0 0 px2rem(30) 0 rgba(0,0,0,0.16);
        border-radius: px2rem(92);
        z-index: 1005;
        &.hide-mini-ani {
            transform: translateX(px2rem(230));
            transition: transform .24s ease 0s;
        }
        &.show-mini-ani {
            transform: translateX(px2rem(-230));
            transition: transform .3s ease .24s;
        }
        .catalog-big-icon {
            width: px2rem(58);
            height: px2rem(46);
            background: url('~public/assets/imgs/ic_catalog_big.png') no-repeat;
            background-size: cover;
            margin: px2rem(40) auto px2rem(14);
        }
        .label {
            font-size: px2rem(36);
            color: #3388FF;
            font-weight: 400;
            text-align: center;
        }
    }
    .fold-mini {
        position: fixed;
        bottom: px2rem(255);
        right: px2rem(-184);
        width: px2rem(184);
        height: px2rem(184);
        background-color: #FFFFFF;
        box-shadow: 0 0 px2rem(30) 0 rgba(0,0,0,0.16);
        border-radius: px2rem(92);
        z-index: 9999;
        &.hide-fold-ani {
            transform: translateX(px2rem(230));
            transition: transform .24s ease 0s;
        }
        &.show-fold-ani {
            transform: translateX(px2rem(-230));
            transition: transform .3s ease .24s;
        }
        .fold-icon {
            width: px2rem(65);
            height: px2rem(65);
            background: url('~public/assets/imgs/ic_fold_content.png') no-repeat;
            background-size: cover;
            margin: px2rem(26) auto px2rem(8);
        }
        .label {
            font-size: px2rem(36);
            color: #3388FF;
            font-weight: 400;
            text-align: center;
        }
    }
</style>